<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <section class="card-style-sec samples-sec p-20">
      <div class="container-fluid">
        <div class="card-main-title">
          <h4 class="card-title">{{ 'Notifications' | translate }}</h4>
        </div>
        <div class="white-box">
          <div class="alert-toolbar-row d-flex justify-content-between align-items-start">
            <div class="search-input-div">
              <div class="input-group mb-2">
                <div class="input-field">
                  <input type="search" #searchField class="search-input mb-0" [placeholder]="'Search Notifications' | translate">
                </div>
                <button type="submit" class="input-group-addon">
                  <label class="label-icon" for="search">
                    <i class="material-icons mb-0">search</i>
                  </label>
                </button>
              </div>
            </div>

            <div class="sort-field grid-settings">
              <button type="button" class="btn filters-icon" [title]="'Filters' | translate" (click)="toggleAlertFilterPanel()">
                <img src="assets/images/grid-settings.svg" alt="grid settings" />
              </button>
            </div>
          </div>

          @if (isAlertFilterPanelOpen) {
            <div class="alert-filter-overlay" (click)="closeAlertFilterPanel()"></div>
          }
          <aside class="alert-filter-panel" [class.open]="isAlertFilterPanelOpen">
            <div class="alert-filter-header">
              <h5>{{ 'Filters' | translate }}</h5>
              <button type="button" class="filter-close-btn" [title]="'Close' | translate" (click)="closeAlertFilterPanel()">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="alert-filters-row">
              <mat-form-field appearance="outline" class="filter-control">
                <mat-label>{{ 'Severity' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedSeverities" multiple>
                  @for (item of severityLookup; track trackByIndex($index)) {
                    <mat-option [value]="item.id">{{ item.name | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="filter-control">
                <mat-label>{{ 'State' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedStates" multiple>
                  @for (item of stateLookup; track trackByIndex($index)) {
                    <mat-option [value]="item.id">{{ item.name | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="filter-control">
                <mat-label>{{ 'Site' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedSiteId">
                  <mat-option [value]="null">{{ 'All' | translate }}</mat-option>
                  @for (site of siteOptions; track trackByIndex($index)) {
                    <mat-option [value]="site.id">{{ site.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="filter-control">
                <mat-label>{{ 'Parameter Name' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedParameterId">
                  <mat-option [value]="null">{{ 'All' | translate }}</mat-option>
                  @for (param of parameterOptions; track trackByIndex($index)) {
                    <mat-option [value]="param.id">{{ param.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="filter-control">
                <mat-label>{{ 'From Date' | translate }}</mat-label>
                <input matInput type="date" [(ngModel)]="startDate" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="filter-control">
                <mat-label>{{ 'To Date' | translate }}</mat-label>
                <input matInput type="date" [(ngModel)]="endDate" />
              </mat-form-field>
            </div>

            <div class="alert-filter-actions">
              <button class="btn btn-submit" (click)="applyAlertFilters()">{{ 'Apply' | translate }}</button>
              <button class="btn btn-cancel" (click)="resetAlertFilters()">{{ 'Reset' | translate }}</button>
            </div>
          </aside>

          <div class="card-inner-main-div">
            <div class="tableColStyle without-borders-table">
              <div class="table-responsive">

                <table mat-table class="table table-striped" [dataSource]="dataSource" matSort multiTemplateDataRows
                  matSortDisableClear>
                  <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let notification">
                      <button mat-icon-button (click)="toggleAlertRow(notification)">
                        <mat-icon class="expandable-icon">{{ notification.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="notificationSentDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Date Sent' | translate }}</th>
                    <td mat-cell *matCellDef="let notification">
                      {{ notification.alertDate | dateFormat: dateTimeFormat }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="notificationName">
                    <th mat-header-cell *matHeaderCellDef>{{ 'Notification Name' | translate }}</th>
                    <td mat-cell *matCellDef="let notification">{{ notification.notificationName | nullDisplay }}</td>
                  </ng-container>

                  <ng-container matColumnDef="severity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Severity' | translate }}</th>
                    <td mat-cell *matCellDef="let notification">
                      <app-severity-chip [severity]="notification.severity" [compact]="true"></app-severity-chip>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'State' | translate }}</th>
                    <td mat-cell *matCellDef="let notification">
                      <span class="state-badge" [ngClass]="notification.stateBadgeClass">
                        {{ notification.stateLabel | translate }}
                      </span>
                      @if (notification.isSuppressed) {
                        <mat-icon class="suppressed-icon"
                          [title]="notification.suppressionReason || ('Suppressed' | translate)"
                          (click)="showSuppressionReason(notification)">
                          notifications_paused
                        </mat-icon>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="endPoint.Name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Site' | translate}}</th>
                    <td mat-cell *matCellDef="let notification">{{ notification.siteDisplayName }}</td>
                  </ng-container>

                  <ng-container matColumnDef="Parameter.AnalyteName" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Parameter Name' | translate }}</th>
                    <td mat-cell *matCellDef="let notification">{{ notification.parameterDisplayName }}</td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th class="action-column" mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</th>
                    <td class="action-column" mat-cell *matCellDef="let notification">
                      @if (notification.effectiveState === alertEventStateEnum.Active || notification.effectiveState === alertEventStateEnum.Escalated) {
                        <button class="btn btn-inline btn-ack"
                          [disabled]="notification.isUpdatingState"
                          (click)="acknowledgeAlert(notification)">
                          {{ 'Acknowledge' | translate }}
                        </button>
                      }
                      @if (notification.effectiveState !== alertEventStateEnum.Resolved) {
                        <button class="btn btn-inline btn-resolve"
                          [disabled]="notification.isUpdatingState"
                          (click)="resolveAlert(notification)">
                          {{ 'Resolve' | translate }}
                        </button>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="graphAction">
                    <th class="graph-action-column" mat-header-cell *matHeaderCellDef>{{ 'Show on Graph' | translate }}</th>
                    <td class="graph-action-column" mat-cell *matCellDef="let notification">
                      <button class="btn btn-inline"
                        [disabled]="!notification.endPointId"
                        (click)="openOnGraph(notification)">
                        {{ 'Show on Graph' | translate }}
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let notification" [attr.colspan]="displayedColumns.length">
                      <div class="alert-detail-panel" [@detailExpand]="notification.isExpanded ? 'expanded' : 'collapsed'">
                        <div class="detail-grid">
                          <div class="detail-section">
                            <div class="detail-title">{{ 'Delivery Status' | translate }}</div>
                            @if (notification.isLoadingDeliveryLogs) {
                              <div class="empty-text">{{ 'Loading...' | translate }}</div>
                            }
                            @if (!notification.isLoadingDeliveryLogs && !(notification.deliveryLogs?.length)) {
                              <div class="empty-text">{{ 'No Delivery Logs Available' | translate }}</div>
                            }
                            @if (!notification.isLoadingDeliveryLogs && notification.deliveryLogs?.length) {
                              <table class="inner-table">
                                <thead>
                                  <tr>
                                    <th>{{ 'Recipient' | translate }}</th>
                                    <th>{{ 'Channel' | translate }}</th>
                                    <th>{{ 'Status' | translate }}</th>
                                    <th>{{ 'Date Sent' | translate }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (delivery of notification.deliveryLogs; track trackByIndex($index)) {
                                    <tr>
                                      <td>{{ delivery.recipientDisplayName || 'N/A' }}</td>
                                      <td>{{ (delivery.displayChannelLabel || 'N/A') | translate }}</td>
                                      <td>{{ delivery.displayStatusLabel | translate }}</td>
                                      <td>{{ delivery.displayDate | dateFormat: dateTimeFormat }}</td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            }
                          </div>

                          <div class="detail-section">
                            <div class="detail-title">{{ 'State Transition Timeline' | translate }}</div>
                            @if (notification.isLoadingStateTransitions) {
                              <div class="empty-text">{{ 'Loading...' | translate }}</div>
                            }
                            @if (!notification.isLoadingStateTransitions && !(notification.stateTransitions?.length)) {
                              <div class="empty-text">{{ 'No transitions' | translate }}</div>
                            }
                            @if (notification.stateTransitions?.length) {
                              <div class="timeline">
                                @for (transition of notification.stateTransitions; track trackByIndex($index)) {
                                  <div class="timeline-item">
                                    <span class="timeline-state">{{ transition.displayToStateLabel | translate }}</span>
                                    <span class="timeline-time">{{ transition.transitionedAt | dateFormat: dateTimeFormat }}</span>
                                    @if (transition.transitionedByUserName) {
                                      <span class="timeline-user">{{ transition.transitionedByUserName }}</span>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (notification.acknowledgedAt) {
                              <div class="timeline">
                                <div class="timeline-item">
                                  <span class="timeline-state">{{ 'Acknowledged' | translate }}</span>
                                  <span class="timeline-time">{{ notification.acknowledgedAt | dateFormat: dateTimeFormat }}</span>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
                  [class.even-row]="even"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"
                  [ngClass]="{ 'hidden-row': !row.isExpanded }"></tr>
                </table>
              </div>
              <mat-paginator appBubblePagination class="mat-pagination-custom"
                [length]="$safeNavigationMigration(dataSource?.count$) | async" [pageSizeOptions]="[5, 10, 20]"
              [pageSize]="10" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>
      </div>
    </section>
  </app-sidebar-layout>
</div>